var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateproject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 83,
    viewBox: "0 0 68 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1735_3584)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1735_3584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1071 22.9496V59.2237C55.1071 61.8668 53.0108 63.963 50.3677 63.963H17.7393C15.0962 63.963 13 61.8668 13 59.2237V11.7393C13 9.09624 15.0962 7 17.7393 7H39.2486C40.4334 7 41.5271 7.4557 42.3474 8.27597L53.8311 19.7597C54.6514 20.6711 55.1071 21.7648 55.1071 22.9496Z",
    fill: "url(#paint0_linear_1735_3584)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.4102 7.56201V17.5534C41.4102 19.4864 43.0471 21.0328 44.9072 21.0328H54.6814C54.4706 20.5794 54.1848 20.1527 53.8311 19.7598L42.3474 8.27601C42.0649 7.99354 41.75 7.7543 41.4102 7.56201Z",
    fill: "url(#paint1_linear_1735_3584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0795 54.0851H19.4792C19.1956 54.0851 18.9688 53.7837 18.9688 53.422C18.9688 53.0602 19.1956 52.7588 19.4792 52.7588H27.0795C27.3631 52.7588 27.59 53.0602 27.59 53.422C27.59 53.844 27.3631 54.0851 27.0795 54.0851Z",
    fill: "url(#paint2_linear_1735_3584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7993 16.9474H19.707C19.3095 16.9474 18.9688 16.6414 18.9688 16.2843C18.9688 15.9272 19.3095 15.6211 19.707 15.6211H36.7993C37.1968 15.6211 37.5375 15.9272 37.5375 16.2843C37.5375 16.6414 37.1968 16.9474 36.7993 16.9474Z",
    fill: "url(#paint3_linear_1735_3584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2495 20.9264H19.7025C19.3074 20.9264 18.9688 20.6204 18.9688 20.2633C18.9688 19.9062 19.3074 19.6001 19.7025 19.6001H26.1931C26.5881 19.6001 26.9268 19.9062 26.9268 20.2633C26.9268 20.6204 26.5881 20.9264 26.2495 20.9264Z",
    fill: "url(#paint4_linear_1735_3584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9382 44.1372H29.0074H26.8107H20.1671C19.8992 44.1372 19.6313 44.4135 19.6313 44.8004C19.6313 45.132 19.8457 45.4635 20.1671 45.4635H26.8107H29.0074H48.9382C49.2061 45.4635 49.474 45.1872 49.474 44.8004C49.4204 44.4135 49.2061 44.1372 48.9382 44.1372Z",
    fill: "url(#paint5_linear_1735_3584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9372 39.4951H41.5303H39.0076H20.1681C19.8997 39.4951 19.6313 39.7714 19.6313 40.1583C19.6313 40.4899 19.846 40.8215 20.1681 40.8215H39.0076H41.5303H48.9372C49.2056 40.8215 49.474 40.5451 49.474 40.1583C49.4203 39.7714 49.2056 39.4951 48.9372 39.4951Z",
    fill: "url(#paint6_linear_1735_3584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9859 34.853H47.061H45.1361H20.166C19.8987 34.853 19.6313 35.1293 19.6313 35.5162C19.6313 35.8478 19.8452 36.1794 20.166 36.1794H45.1361H47.2749H48.9324C49.1998 36.1794 49.4671 35.903 49.4671 35.5162C49.5206 35.1846 49.2532 34.853 48.9859 34.853Z",
    fill: "url(#paint7_linear_1735_3584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9439 30.2109H42.7422H41.205H20.1614C19.8964 30.2109 19.6313 30.4873 19.6313 30.8741C19.6313 31.2057 19.8434 31.5373 20.1614 31.5373H41.205H42.7422H48.8909C49.2619 31.5373 49.474 31.261 49.474 30.8741C49.474 30.5425 49.262 30.2109 48.9439 30.2109Z",
    fill: "url(#paint8_linear_1735_3584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2791 64.0684C55.7524 64.0684 61.0001 58.8208 61.0001 52.3474C61.0001 45.8741 55.7524 40.6265 49.2791 40.6265C42.8058 40.6265 37.5581 45.8741 37.5581 52.3474C37.5581 58.8208 42.8058 64.0684 49.2791 64.0684Z",
    fill: "url(#paint9_linear_1735_3584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8259 51.4103H50.3666V48.951C50.3666 48.4592 49.9841 48.022 49.4376 48.022C48.9457 48.022 48.5085 48.4045 48.5085 48.951V51.4103H46.0492C45.5573 51.4103 45.1201 51.7929 45.1201 52.3394C45.1201 52.8859 45.5027 53.2685 46.0492 53.2685H48.5085V55.7278C48.5085 56.2196 48.891 56.6568 49.4376 56.6568C49.9294 56.6568 50.3666 56.2743 50.3666 55.7278V53.2685H52.8259C53.3178 53.2685 53.755 52.8859 53.755 52.3394C53.755 51.7929 53.3178 51.4103 52.8259 51.4103Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1735_3584",
    x: 0.747361,
    y: 0.873681,
    width: 66.6122,
    height: 81.4682,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.12632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.12632
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1735_3584"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1735_3584",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1735_3584",
    x1: 34.0398,
    y1: 5.68239,
    x2: 34.0398,
    y2: 64.5771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1735_3584",
    x1: 54.725,
    y1: 14.0705,
    x2: 42.8732,
    y2: 14.1201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828138,
    stopColor: "#B2B9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1735_3584",
    x1: 23.1051,
    y1: 54.0658,
    x2: 23.0838,
    y2: 52.7604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F366B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1735_3584",
    x1: 27.8778,
    y1: 16.9281,
    x2: 27.8679,
    y2: 15.6224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F366B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1735_3584",
    x1: 22.7869,
    y1: 20.9071,
    x2: 22.7639,
    y2: 19.6018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F366B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1735_3584",
    x1: 33.9494,
    y1: 45.4442,
    x2: 33.9433,
    y2: 44.1385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F366B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1735_3584",
    x1: 33.9494,
    y1: 40.8022,
    x2: 33.9433,
    y2: 39.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F366B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1735_3584",
    x1: 33.9494,
    y1: 36.1601,
    x2: 33.9433,
    y2: 34.8543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F366B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1735_3584",
    x1: 33.9494,
    y1: 31.518,
    x2: 33.9433,
    y2: 30.2122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F366B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1735_3584",
    x1: 37.5474,
    y1: 52.35,
    x2: 61.0043,
    y2: 52.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57ACE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BD0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1735_3584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 83,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateproject);
export default __webpack_public_path__ + "static/media/createproject.c986ce6418cb3e9f2f149b4308409075.svg";
export { ForwardRef as ReactComponent };